/**
 * Label for a PPD-credited pick (DKPLAT-478). The credit type comes from the value
 * persisted at grading time (`ppdStatus`) so it can't flip when the live fixture
 * status later changes or fails to load; entries graded before ppdStatus existed
 * fall back to the live fixture status as before.
 */
export function getPpdCreditLabel(
  ppdStatus: string | null | undefined,
  fixtureStatus: string | null | undefined
): 'Cancelation Credit' | 'Postponement Credit' {
  return (ppdStatus ?? fixtureStatus) === 'cancelled'
    ? 'Cancelation Credit'
    : 'Postponement Credit';
}
